module.exports = __webpack_public_path__ + "static/media/home-2.c8bb312a.mp4";